// src/pages/CustomerSpecialPrice/CustomerSpecialPriceSlice.js
import { createSlice } from "@reduxjs/toolkit";
import {
  fetchCustomerSpecialPriceList,
  saveCustomerSpecialPrice,
  deleteCustomerSpecialPrice,
} from "./CustomerSpecialPriceThunk";

const initialState = {
  list: [],
  items: [],
  customersGroups: [],
  loading: false,
  loadingSave: false,
  accessType: "WRITE",
  isEdit: false,
  formData: null,
};

const slice = createSlice({
  name: "customerSpecialPrice",
  initialState,
  reducers: {
    resetForm: (state) => {
      state.isEdit = false;
      state.formData = null;
    },
    setCustomersGroups: (state, action) => {
      state.customersGroups = action.payload;
    },
    setItems: (state, action) => {
      state.items = action.payload;
    },
    setEditForm: (state, action) => {
  const record = action.payload;

  // Try to extract type from display_name (inside parentheses)
  let type = null;
  const match = record.display_name?.match(/\(([^)]+)\)/);
  if (match) {
    type = match[1].toLowerCase(); // "customer" or "group"
  }

  state.isEdit = true;
  state.formData = {
    ...record,
    account_id: record.acc_id,  // normalize naming
    type: type || "customer",   // default fallback
  };
    },

  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomerSpecialPriceList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCustomerSpecialPriceList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(saveCustomerSpecialPrice.pending, (state) => {
        state.loadingSave = true;
      })
      .addCase(saveCustomerSpecialPrice.fulfilled, (state) => {
        state.loadingSave = false;
        state.isEdit = false;
        state.formData = null;
      })
      .addCase(deleteCustomerSpecialPrice.fulfilled, (state, action) => {
        state.list = state.list.filter((x) => x.id !== action.payload);
      });
  },
});

export const { resetForm, setCustomersGroups, setItems, setEditForm } = slice.actions;
export default slice.reducer;
